import lodash from 'lodash';
Vue.prototype._ = lodash

import Vue from 'vue'
import App from './App.vue'
import VueLodash from 'vue-lodash'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueLazyload from 'vue-lazyload'
import VueCarousel from 'vue-carousel'
import Components from './components'
import Icon from 'vue-awesome/components/Icon'
import Msg from 'vue-message'
import axios from 'axios'
import VueAxios from 'vue-axios'
import SocialSharing from 'vue-social-sharing'
import VueMeta from 'vue-meta'
import VueLocalStorage from 'vue-localstorage'

import './lodash'
import 'vue-awesome/icons'
import './assets/css/font.css'

import { createRouter } from './router'
import StoreService from './services/store.service'

Vue.config.productionTip = false

Vue.use(VueLodash)
Vue.use(VueMoment, {
  moment,
})
Vue.use(VueLazyload)
Vue.use(VueCarousel);
Vue.use(Components);
Vue.use(Msg)
Vue.use(VueAxios, axios)
Vue.use(SocialSharing);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(VueLocalStorage, {
  name: 'context',
  bind: true //created computed members from your variable declarations
})

Vue.config.productionTip = false

Vue.component('v-icon', Icon);

const router = createRouter()
const store = StoreService.createStore()
moment.locale('fr')

new Vue({
  router,
  data: store,
  render: h => h(App)
}).$mount('#app')

